import React from 'react';
import PropTypes from 'prop-types';

import GeneralInfo from '../mapbox-popup-general-info/index';

import '../../../../styles/row-hover-tooltip.scss';

/*
 * Mapbox popup customized for our use case. We can modify this component e.g. adding quantity picker and checkout button as props to improve reusability
 */
const RowTooltip = ({row = '', price = {}, type = 'row'}) => {
  return <GeneralInfo row={row} price={price} type={type} className="MapboxRowHoverTooltip__Info" />;
};

RowTooltip.propTypes = {
  /** The row id. */
  row: PropTypes.string.isRequired,

  /** The price with currency. */
  price: PropTypes.object.isRequired,

  /** The type of tooltip. */
  type: PropTypes.string.isRequired,
};

export default RowTooltip;
